var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.9997 6.33301C20.583 6.33301 6.33301 20.583 6.33301 37.9997C6.33301 55.4163 20.583 69.6663 37.9997 69.6663C55.4163 69.6663 69.6663 55.4163 69.6663 37.9997C69.6663 20.583 55.4163 6.33301 37.9997 6.33301ZM37.9997 63.333C24.0347 63.333 12.6663 51.9647 12.6663 37.9997C12.6663 24.0347 24.0347 12.6663 37.9997 12.6663C51.9647 12.6663 63.333 24.0347 63.333 37.9997C63.333 51.9647 51.9647 63.333 37.9997 63.333ZM52.5347 24.003L31.6663 44.8713L23.4647 36.7013L18.9997 41.1663L31.6663 53.833L56.9997 28.4997L52.5347 24.003Z",
    fill: "#FE6728"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.115ed57ebe7bb01af7c767b38e5c89a0.svg";
export { ForwardRef as ReactComponent };